import styled, { css } from "styled-components";

export const RecoverButtonStyled = styled.button`
	color: var(--color-whiteTrueAlways-darken-200);
	border-radius: 0.75rem;
	padding: 0.25rem 0.75rem;
	background-color: rgba(0, 0, 0, 0.25);
	font-size: 0.9rem;
	box-shadow: var(--dz-sys-auth-panel-shadow);

	&:hover,
	&:focus {
		background-color: rgba(0, 0, 0, 0.35);
		text-decoration: underline;
	}

	white-space: nowrap;

	${({ $isModal, authModalVersion }) =>
		$isModal && authModalVersion === "darkAndLight"
			? css`
					color: var(--dz-sys-text-color);
					background-color: ${({ theme: { isDarkMode } }) =>
						isDarkMode ? "rgba(0, 0, 0, 0.25)" : "#dbdbdb"};
					border: ${({ theme: { isDarkMode } }) =>
						isDarkMode ? "1px solid #878787" : "none"};
					box-shadow: ${({ theme: { isDarkMode } }) =>
						isDarkMode
							? "var(--dz-sys-auth-panel-shadow)"
							: "0 1px 2px 0 rgb(0 0 0 / 0.6),0 1px 2px -1px rgb(0 0 0 / 0.6)"};
					&:hover,
					&:focus {
						background-color: ${({ theme: { isDarkMode } }) =>
							isDarkMode
								? "rgba(0, 0, 0, 0.35)"
								: "rgba(255, 255, 255, 0.35)"};
					}
			  `
			: $isModal &&
			  css`
					color: var(--color-whiteTrueAlways-darken-200);
					background-color: rgba(0, 0, 0, 0.25);
					border: 1px solid #646464;
			  `}
`;
